// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","ArrowHeight":"30px","arrow":"Gce76c7","arrow--top":"G824d39","arrow--bottom":"G235844","arrow--left":"G2f0a71","arrow--right":"G355699"};